import type { Store } from 'redux'
import { coordinatesInvalidate, coordinatesSet } from '../actions/common'
import type { IState } from '../reducers'

const positionOptions: PositionOptions = {
    enableHighAccuracy: true,
    maximumAge: Infinity,
}

/**
 * In mobile devices, we should use a watch function to store the location of the device in order to minimize
 * the wait time when executing a request to the GPS, a request can take up to 2 seconds which heavily reduces
 * the UI performance.
 */
export async function createCoordinatesWatch(store: Store<IState>) {
    if (window.onWinGeolocate) {
        // Listen for changes from WinGeolocate.exe
        window.onWinGeolocate = (lat, lon) => {
            store.dispatch(coordinatesSet(lat, lon))
        }
        return
    }

    const onSet = (position: GeolocationPosition) => {
        // If null invalidate
        if (position == null) {
            /* eslint-disable-next-line no-console */
            console.warn('Invalid coordinates received')

            // Avoid updating if already invalid
            const { lat, lon } = store.getState().common
            if (lat == null && lon == null) return

            store.dispatch(coordinatesInvalidate())
            return
        }

        // Otherwise update with new coordinates

        // Avoid updating if already similar coordinates
        {
            const { lat, lon } = store.getState().common
            if (!isSimilar(lat, position.coords.latitude) || !isSimilar(lon, position.coords.longitude)) {
                store.dispatch(coordinatesSet(position.coords.latitude, position.coords.longitude))
            }
        }
    }

    navigator.geolocation.watchPosition(onSet, onError, positionOptions)
}

function onError(error: GeolocationPositionError) {
    /* eslint-disable-next-line no-console */
    console.error('Coordinates error: ' + error.message)
}

function isSimilar(a: number, b: number) {
    if (a == null || b == null) return a == null && b == null
    return a.toFixed(4) === b.toFixed(4)
}
